import React from 'react';
import escudo from '../../assets/imagenes/escudo.svg';

// eslint-disable-next-line no-unused-vars
const EnConstruccion = props => (
  <div style={{ textAlign: 'center', margin: 20 }}>
    <img
      height="400"
      width="400"
      alt="Logo Poder Judicial de Neuquén"
      src={escudo}
    />
  </div>
);

export default EnConstruccion;
